import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Auth from "./Layouts/Auth/Auth";

import NewUser from "./Layouts/NewUser/NewUser";

import Login from "./Pages/LoginPages/Login";

import IdentityDetail from "./Pages/NewUserPages/Forms/IdentityDetail";
import PersonalDetails from "./Pages/NewUserPages/Forms/PersonalDetails";

import BankDetails from "./Pages/NewUserPages/Forms/BankDetails";
import UploadDocuments from "./Pages/NewUserPages/Forms/UploadDocuments";
import Nominee from "./Pages/NewUserPages/Forms/Nominee";
import OfferLetter from "./Pages/NewUserPages/Forms/OfferLetter";
import PdfViewer from "./Pages/PdfViewer";
import { useEffect, useState } from "react";
import axios from "axios";
import Welcome from "./Pages/Welcome/Welcome";
function App() {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    axios
      .get("/employee-connect/authentication/auth-verify", {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.success) {
          const userData = res.data.data;

          // ✅ EXACT SAME SAVE LOGIC AS OTP
          localStorage.setItem("firstName", userData?.name?.first_name);
          localStorage.setItem("middleName", userData?.name?.middle_name);
          localStorage.setItem("lastName", userData?.name?.last_name);
          localStorage.setItem("fullName", userData?.name?.full_name);

          localStorage.setItem("personalEmail", userData?.email?.personal);
          localStorage.setItem("companyEmail", userData?.email?.company);

          localStorage.setItem("userId", userData?._id);
          localStorage.setItem("authorization", userData?.authorization);
          localStorage.setItem(
            "authorization_level",
            userData?.authorization_level,
          );

          localStorage.setItem("userType", "newUser");

          localStorage.setItem("isLoggedIn", "true");

          setIsAuthenticated(true);
        } else {
          localStorage.clear();
          setIsAuthenticated(false);
        }

        setAuthChecked(true);
      })
      .catch(() => {
        localStorage.clear();
        setIsAuthenticated(false);
        setAuthChecked(true);
      });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/auth"
          element={
            !authChecked ? (
              <div>Loading...</div>
            ) : isAuthenticated ? (
              <Navigate to="/employee/welcome" replace />
            ) : (
              <Auth />
            )
          }
        >
          {!isAuthenticated && <Route index element={<Login />} />}
        </Route>

        <Route path="/privacy-policy" element={<PdfViewer />} />
        <Route path="/tnc" element={<PdfViewer />} />
        <Route path="/employee/welcome" element={<Welcome />} />

        <Route path="/new-user" element={<NewUser />}>
          {/* <Route index element={<Navigate to="welcome" replace />} /> */}
          <Route index element={<Navigate to="personal" replace />} />
          <Route path="personal" element={<PersonalDetails />} />
          <Route path="identity-detail" element={<IdentityDetail />} />
          <Route path="documents" element={<UploadDocuments />} />
          <Route path="nominees" element={<Nominee />} />
          <Route path="bank-details" element={<BankDetails />} />
          <Route path="offer-letter" element={<OfferLetter />} />
          <Route path="*" element={<Navigate to="personal" replace />} />
          {/* <Route path="*" element={<Navigate to="welcome" replace />} /> */}
        </Route>

        <Route
          path="/"
          element={
            !authChecked ? (
              <div>Loading...</div>
            ) : isAuthenticated ? (
              <Navigate to="/employee/welcome" replace />
            ) : (
              <Navigate to="/auth" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
